import {
    post,
    get,
    put,
    del
} from "./http"

const home = {
    //  获得三十天消息统计数
    getInfo() {
        return get("client/dashboard/messages")
    },
    getdashboard() {
        return get("client/dashboard")
    },
    // 充值
    pay(param) {
        return post("client/recharge-order", param)
    },
    recharge(id, param) {
        return put("client/recharge-order/" + id + "/pay-status", param)
    }
}
export default home